import { useTheme } from '@material-ui/core';
import { colorStringToHex } from '@timeflies/common';
import * as PIXI from 'pixi.js';
import React from 'react';
import { CustomPIXIComponent } from 'react-pixi-fiber';
var TileHighlight = CustomPIXIComponent({
    customDisplayObject: function () { return new PIXI.Graphics(); },
    customApplyProps: function (graphics, oldProps, newProps) {
        var color = newProps.color, alpha = newProps.alpha, _a = newProps.x, x = _a === void 0 ? 0 : _a, _b = newProps.y, y = _b === void 0 ? 0 : _b, width = newProps.width, height = newProps.height;
        graphics.clear();
        if (color) {
            graphics.beginFill(color, alpha);
            graphics.drawRect(x, y, width, height);
            graphics.endFill();
        }
    }
}, 'TileHighlight');
export var TilemapTileHighlight = function (_a) {
    var isRange = _a.isRange, isAction = _a.isAction, isCurrentAction = _a.isCurrentAction, size = _a.size;
    var tileStatesColors = useTheme().palette.tileStates;
    var rangeColor = colorStringToHex(tileStatesColors.range);
    var actionColor = colorStringToHex(tileStatesColors.action);
    var mainColor = isAction || isCurrentAction
        ? actionColor
        : (isRange
            ? rangeColor
            : null);
    var mainAlpha = isAction
        ? 0.75
        : (isRange
            ? 0.5
            : (isCurrentAction
                ? 0.25
                : 0));
    var innerColor = isAction && isRange
        ? rangeColor
        : null;
    var innerAlpha = isAction && isRange
        ? 0.75
        : 0;
    var innerSize = size * 2 / 3;
    var innerPos = (size - innerSize) / 2;
    return (React.createElement(React.Fragment, null,
        React.createElement(TileHighlight, { width: size, height: size, color: mainColor, alpha: mainAlpha }),
        React.createElement(TileHighlight, { x: innerPos, y: innerPos, width: innerSize, height: innerSize, color: innerColor, alpha: innerAlpha })));
};
